import './index.css';
import './i18n';
import { App } from 'src/App';
import store from 'src/shared/services/store';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/sv';
import theme from 'src/shared/components/styles/theme';
import { AppContext } from 'src/shared/contexts/appContext';
import { createRoot } from 'react-dom/client';
import userManager from './userManager';
import reportWebVitals from './reportWebVitals';
import { MemberContextProvider } from './shared/contexts/memberContext';
import { EventContextProvider } from './shared/contexts/eventContext';
import { InvoiceContextProvider } from './shared/contexts/invoiceContext';
import { FundraiserContextProvider } from './shared/contexts/fundraiserContext';
// import { StatisticsContextProvider } from './shared/contexts/statisticsContext';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const root = createRoot(document.getElementById('root') as Element);
root.render(
  <>
    <Provider store={store}>
      {/* @ts-expect-error Server Component */}
      <OidcProvider store={store} userManager={userManager}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
          <AppContext>
            <MemberContextProvider>
              <FundraiserContextProvider>
                <InvoiceContextProvider>
                  <EventContextProvider>
                    <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={theme}>
                        <App />
                      </ThemeProvider>
                    </StyledEngineProvider>
                  </EventContextProvider>
                </InvoiceContextProvider>
              </FundraiserContextProvider>
            </MemberContextProvider>
          </AppContext>
        </LocalizationProvider>
      </OidcProvider>
    </Provider>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
